import {
    SET_DOCUMENT, LOAD_DOCUMENT, LOAD_DOCUMENT_SUCCESS, LOAD_DOCUMENT_FAILURE,
    LOAD_DOCUMENT_IMAGE, LOAD_DOCUMENT_IMAGE_SUCCESS, LOAD_DOCUMENT_IMAGE_FAILURE,
    SET_NEXT_INPUT_TYPE, ADD_INPUT, DELETE_INPUT,
    MOVE_INPUT_ON_DOCUMENT, UPDATE_INPUT_ON_DOCUMENT, SAVE_CURRENT_DOCUMENT_SUCCESS,
    GET_ALL_STATIC_DOCUMENTS, RECEIVED_ALL_STATIC_DOCUMENTS, GET_USERS_DOCUMENTS, RECEIVED_ALL_USER_DOCUMENTS,
    FINALIZE_DOCUMENT, FINALIZE_DOCUMENT_SUCCESS
} from '../../_actions/types';

const defaultState = {
    isFetchingAllDocuments: false,
    isFetchingUserDocuments: false,
    isDocumentLoading: false,
    isDocumentLoaded: false,
    isDocumentImageLoading: false,
    isDocumentImageLoaded: false,
    isDocumentFinished: false,
    addingInput: false,
    staticDocuments: [],
    userDocuments: [],
    imageUrl: null,
    name: 'RF302',
    inputType: null,
    formData: {},
};

export default function EditorReducer(state = defaultState, action) {
    switch (action.type) {
        case GET_ALL_STATIC_DOCUMENTS:
            return {
                ...state,
                isFetchingAllDocuments: true
            };

        case RECEIVED_ALL_STATIC_DOCUMENTS:
            return {
                ...state,
                staticDocuments: action.documents
            };

        case GET_USERS_DOCUMENTS:
            return {
                ...state,
                isFetchingUserDocuments: true
            };

        case RECEIVED_ALL_USER_DOCUMENTS:
            return {
                ...state,
                userDocuments: action.documents
            };

        case SET_DOCUMENT:
            return {
                ...state,
                name: action.name
            };

        case LOAD_DOCUMENT:
            return {
                ...state,
                isDocumentLoading: true,
                isDocumentLoaded: false,
                isDocumentImageLoading: false,
                isDocumentImageLoaded: false,
                name: action.name,
                addingInput: false,
                inputType: null
            };

        case LOAD_DOCUMENT_SUCCESS:
            return {
                ...state,
                isDocumentLoading: false,
                isDocumentLoaded: true,
                formData: action.formData
            };

        case LOAD_DOCUMENT_FAILURE:
            return {
                ...state,
                isDocumentLoading: false,
                isDocumentLoaded: false
            };

        case LOAD_DOCUMENT_IMAGE:
            return {
                ...state,
                isDocumentImageLoading: true,
                isDocumentImageLoaded: false,
                imageName: action.imageName
            }

        case LOAD_DOCUMENT_IMAGE_SUCCESS:
            return {
                ...state,
                isDocumentImageLoading: false,
                isDocumentImageLoaded: true,
                imageUrl: action.imageUrl
            };

        case LOAD_DOCUMENT_IMAGE_FAILURE:
            return {
                ...state,
                isDocumentImageLoading: false,
                isDocumentImageLoaded: false,
            };

        case SET_NEXT_INPUT_TYPE:
            return {
                ...state,
                inputType: action.docType,
                addingInput: true
            };

        case ADD_INPUT:
            const newInput = makeNewInput(state.inputType, action.top, action.left);
            if (!state.addingInput || !newInput) {
                return state;
            }

            return {
                ...state,
                formData: {
                    ...state.formData,
                    [newInput.id]: {
                        ...newInput
                    }
                },
                addingInput: false
            };

        case DELETE_INPUT:
            let newFormData = { ...state.formData };
            delete newFormData[action.id];

            return {
                ...state,
                formData: newFormData
            };

        case SAVE_CURRENT_DOCUMENT_SUCCESS:
            return {
                ...state,
                userDocuments: {
                    ...state.userDocuments,
                    [action.id]: {
                        name: action.name
                    }
                }
            };

        case UPDATE_INPUT_ON_DOCUMENT:
            const updatedInput = {
                ...state.formData[action.id],
                value: action.value
            };

            return {
                ...state,
                formData: {
                    ...state.formData,
                    [action.id]: updatedInput
                }
            };

        case MOVE_INPUT_ON_DOCUMENT:
            const movedInput = {
                ...state.formData[action.id],
                top: action.top,
                left: action.left
            };

            return {
                ...state,
                formData: {
                    ...state.formData,
                    [action.id]: movedInput
                }
            };

        case FINALIZE_DOCUMENT:
            return {
                ...state,
                isDocumentFinished: true
            };


        case FINALIZE_DOCUMENT_SUCCESS:
            return {
                ...state,
                isDocumentFinished: false
            };

        default:
            return state;
    }
}

function makeNewInput(type, top, left) {
    switch (type) {
        case 'text':
            return {
                id: uuid(),
                type,
                top,
                left,
                width: 100,
                value: 'New Input'
            };

        case 'checkbox':
            return {
                id: uuid(),
                type,
                top,
                left,
                value: false
            };

        case 'date':
            const today = new Date();
            return {
                id: uuid(),
                type,
                top,
                left,
                value: today.toISOString().substr(0, 10),
            };

        case 'signature':
            return {
                id: uuid(),
                type,
                top,
                left,
                value: null,
                width: 300,
                height: 100
            };

        default:
            return null;
    }
}

// We can probably just use Firebase when we start storing this data in the DB (assuming we actually do)
function uuid() {
    return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
        // eslint-disable-next-line
        (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
    )
}



// WEBPACK FOOTER //
// ./src/components/document-editor/editor_reducer.js